import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import { isGiftListSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useWeddingWebsiteData } from '../../data/data-context';
import { MotifOrnament, MotifSectionHookProps } from './motif-section-hooks';

export const MotifGiftList = (hookProps: MotifSectionHookProps) => {
  const { t } = useTranslation('weddingWebsite');
  const { website, isGuestView } = useWeddingWebsiteData();
  const section = website.sections.find(isGiftListSection);
  const dispatch = useDispatch();

  const url = section?.data.url;
  const hasUrl = !!url && url !== '';

  const handleClick = useCallback(() => {
    if (isGuestView) {
      dispatch(
        clickedOnLoggedOutPage({
          clickedLocation: 'weddingWebsites',
          clickedSection: 'giftList',
          cta: 'View our gift list',
          trackingTarget: 'BigQuery',
        }),
      );
    }
  }, [dispatch, isGuestView]);

  return (
    <section {...hookProps} className="bb-ww__section bb-ww__section--gift">
      <MotifOrnament />
      <h2 className="bb-ww__section-title">{t('previewMode.tile.giftList.title')}</h2>
      <p className="bb-ww__body">{section?.data.message}</p>
      {hasUrl ? (
        <a
          className="bb-ww__button bb-ww__button--gift"
          href={url}
          target="_blank"
          rel="noreferrer"
          onClick={handleClick}>
          {t('previewMode.tile.giftList.viewGiftList')}
        </a>
      ) : (
        <button className="bb-ww__button bb-ww__button--gift" type="button" onClick={handleClick}>
          {t('previewMode.tile.giftList.viewGiftList')}
        </button>
      )}
    </section>
  );
};
